import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { ACHPaymentsSections } from '../enums';
import useQueryMatch from 'hooks/useQueryMatch';
import BasePageLabel from 'components/wrappers/BasePageLabel';
import UnprocessedPaymentsSection from './UnprocessedPaymentsSection';

const DEFAULT_SECTION = ACHPaymentsSections.UnprocessedPayments;

const pageSections = [DEFAULT_SECTION];

export default function ACHPaymentsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const pageSectionMatch = useQueryMatch(pageSections);
  const query = queryString.parse(location.search);

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line
  }, [pageSectionMatch]);

  const getPaymentsSection = () => {
    switch (query.section) {
      case ACHPaymentsSections.UnprocessedPayments:
      default:
        return <UnprocessedPaymentsSection />;
    }
  };

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-holder">
        <BasePageLabel label="ACH payments" />

        {getPaymentsSection()}
      </div>
    </div>
  );
}
